import { Container, Row, Col, Button } from "react-bootstrap";
import { useContext, useState } from "react";
import "../css/login.css";
import { AuthContext } from "../../../services/auth";

const Login = () => {
  const auth = useContext(AuthContext);
  const { login } = auth;
  const initialFormData = Object.freeze({
    username: "",
    password: "",
  });
  const [formData, updateFormData] = useState(initialFormData);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    updateFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };

  const handleLogin = async () => {
    const success = await login(formData);
    if (success) {
      window.location.replace("/admin/");
    } else {
      setError("Username o password errati");
    }
  };
  return (
    <Container
      fluid
      className=" d-flex justify-content-center align-items-center padding_custom text_data"
    >
      <Container>
        <h2 className="text-center section-title mt-5">LOGIN</h2>
        <div className="border-custom mt-3 mb-5"></div>
        <Container className="container-input-login pt-5">
          <Row className="py-3">
            <Col lg={{ span: 6, offset: 3 }}>
              <label className="form-label" htmlFor="usernameField">
                <small><strong>USERNAME</strong></small>
              </label>
              <input
                id="usernameField"
                onChange={handleChange}
                className="form-control"
                placeholder="Inserisci username"
                name="username"
                type="text"
              />
            </Col>
          </Row>

          <Row className="py-3">
            <Col lg={{ span: 6, offset: 3 }}>
              <label className="form-label" htmlFor="passwordField">
                <small><strong>PASSWORD</strong></small>
              </label>
              <input
                id="passwordField"
                onChange={handleChange}
                type="password"
                className="form-control"
                placeholder="Inserisci password"
                name="password"
              />
            </Col>
          </Row>

          {error && (
            <Row>
              <Col className="text-danger text-center">{error}</Col>
            </Row>
          )}
          <Row className="m-0">
            <Col className="py-5 text-center text_data">
              <Button
                variant=""
                type="submit"
                className="text-center button-custom-contacts"
                onClick={handleLogin}
              >
                Login
              </Button>
            </Col>
          </Row>
        </Container>
      </Container>
    </Container>
  );
};

export default Login;
